import { OfferStatusHistoryModel } from './../models/offer/offerStatusHistoryModel';
import { FileSyncModel } from './../models/synchronization/fileSyncModel';
import { OfferInstallationSyncModel } from './../models/synchronization/offerInstallationSyncDTO';
import { UserModel } from './../models/user/userModel';
import { LocationSyncModel } from './../models/synchronization/locationSyncModel';
import { ClientSyncModel } from './../models/synchronization/clientSyncModel';
import Dexie from 'dexie';
import { ProductToProductModel } from '../models/product/productToProductModel';
import { OfferStatus } from './enums';

export class AppDatabase extends Dexie {
    products: Dexie.Table<IProduct, number>;
    categories: Dexie.Table<ICategory, number>;
    offers: Dexie.Table<IOffer, number>;
    clients: Dexie.Table<IClient, number>;
    locations: Dexie.Table<ILocation, number>;
    deletedOffers: Dexie.Table<IDeletedOffer, number>;
    productImages: Dexie.Table<IProductImage, number>;

    constructor() {
        super("OvergasMobileDatabase");

        this.version(1).stores({
            products: '++id, remoteId, categoryId, articleNumber, brand, model, power, price, discount, ' +
                'description, isActive, installationActivities, fasteners',
            categories: '++id, remoteId, parentId, name, levelNo, orderNo, isActive'
        });

        this.version(2).stores({
            products: '++id, remoteId, articleNumber, articel, brand, power, supplier',
            categories: '++id, remoteId, name',
            offers: '++id, remoteId, number, clientName, locationAddress, locationDistrict, locationTown'
        }).upgrade(tx => {
            localStorage.setItem('lastSyncDate', '');
        });

        this.version(3).stores({
            products: '++id, remoteId, articleNumber, article, brand',
            clients: '++id, remoteId, name',
            locations: '++id, remoteId, clientId'
        }).upgrade(tx => {
            localStorage.setItem('lastSyncDate', '');
        });

        this.version(4).stores({
            products: '++id, remoteId, articleNumber, article, brand, model, power, supplier, description'
        }).upgrade(tx => {
            localStorage.setItem('lastSyncDate', '');
        });

        this.version(5).stores({
            offers: '++id, remoteId, number, clientName, locationAddress, locationDistrict, locationTown, reported'
        }).upgrade(tx => {
            localStorage.setItem('lastSyncDate', '');
        });

        this.version(6).stores({
            clients: '++id, remoteId, name, reported',
            locations: '++id, remoteId, clientId, reported'
        }).upgrade(tx => {
            localStorage.setItem('lastSyncDate', '');
        });

        this.version(7).stores({
            offers: '++id, [reported+statusId], remoteId, number, clientName, locationAddress, locationDistrict, locationTown, reported'
        }).upgrade(tx => {
            localStorage.setItem('lastSyncDate', '');
        });

        this.version(8).stores({
            offers: '++id, [reported+statusId], statusId, date, remoteId, number, clientName, locationAddress, locationDistrict, locationTown, reported'
        }).upgrade(tx => {
            localStorage.setItem('lastSyncDate', '');
        });

        this.version(9).stores({
            deletedOffers: '++id, remoteId'
        }).upgrade(th => {
            localStorage.setItem('lastSyncDate', '');
        });

        this.version(10).stores({
            productImages: '++id, remoteId'
        }).upgrade(th => {
            localStorage.setItem('lastSyncDate', '');
        });

        this.version(11).stores({
            products: '++id, remoteId, articleNumber, article, brand, model, power, supplier, description, relatedProducts'
        }).upgrade(th => {
            localStorage.setItem('lastSyncDate', '');
        });

        this.version(12).stores({
        }).upgrade(th => {
            localStorage.setItem('lastSyncDate', '');
        });

        this.products = this.table('products');
        this.categories = this.table('categories');
        this.offers = this.table('offers');
        this.clients = this.table('clients');
        this.locations = this.table('locations');
        this.deletedOffers = this.table('deletedOffers');
        this.productImages = this.table('productImages');
    }
}

export interface IProduct {
    id?: number;
    remoteId: number;
    categoryId: number;
    category: string;
    articleNumber: string;
    article: string;
    brand: string;
    model: string;
    power: number;
    secondPower: number;
    supplier: string;
    price: number;
    priceFromSupplier: number;
    discount: number;
    description: string;
    unitId: number;
    isActive: boolean;
    fileId: number;
    diameter: number;
    relatedProducts: Array<ProductToProductModel>;
}

export interface ICategory {
    id?: number;
    remoteId: number;
    parentId: number;
    name: string;
    levelNo: number;
    orderNo: number;
    isActive: boolean,
    categoryTypeId: number,
}

export interface IOffer {
    id?: number;
    remoteId: number;
    date: string;
    number: string;
    notes: string;
    price: number;
    discount: number;
    fixedDiscount: number;
    traderId: number,
    clientId: number;
    statusId: OfferStatus;
    clientEmail: string;
    clientName: string;
    clientPhone: string;
    isActive: boolean;
    locationAddress: string;
    locationDistrict: string;
    locationId: number;
    locationMunicipality: string;
    locationTown: string;
    locationLatitude: string;
    locationLongitude: string;
    client: ClientSyncModel;
    location: LocationSyncModel;
    trader: UserModel;
    isolationTypeId: number;
    roomHeight: number;
    planner: string;
    activeStep: number;
    completedSteps: string;
    isWithHeathInstall: boolean;
    isWithWorkAndMaterials: boolean;
    disclaimer: string;
    adminNotes: string;
    gasInstallation: OfferInstallationSyncModel;
    heathInstallation: OfferInstallationSyncModel | null;
    files: Array<FileSyncModel>;
    reported: number;
    updatedOn: string;
    priceChanged: boolean;
    remoteUpdatedOn: string;
    statusHistory: Array<OfferStatusHistoryModel>;
    equipmentOnly: boolean;
}

export interface IClient {
    id?: number;
    remoteId: number;
    name: string;
    email: string;
    phone: string;
    reported: number;
}

export interface ILocation {
    id?: number;
    remoteId: number;
    clientId: number;
    district: string;
    municipality: string;
    town: string;
    address: string
    reported: number;
    latitude: string;
    longitude: string;
}

export interface IProductImage {
    id?: number;
    remoteId: number;
    name: string;
    contentType: string;
    content: string;
}

export interface IDeletedOffer {
    id?: number;
    remoteId: number;
}

export default AppDatabase;
//export var db = new AppDatabase();